export default {
  SET_externalEmployee(state, payload) {
    state.external_employees = payload
  },
}
